<template>
    <div name="home" class="wrapper">
        <loading v-if="isLoading" />

        <div class="page">
            <outlink-popup 
                v-if="isOutlinkPopup"
                :link="outLink"
                @close="closeOutlinkPopup"
            />
            <!-- <notification-modal 
                v-if="isNotification"
                @close="notificationModalClose"
                @neverAgain="notificationCloseNeverAgain"
            /> -->
            <!-- <common-modal 
                :title="'시스템 점검중'"
                :message="'안녕하세요, 솔닥입니다.<br><br>더 안정적인 서비스 제공을 위해 아래 시간 동안 시스템 점검이 진행될 예정입니다.<br><br>점검 일시: 2026.09.14 월요일 오후 21:00 ~ 23:00<br><br>점검 시간 동안은 서비스 접속 및 이용이 어려울 수 있으며, 점검 완료 후 정상적으로 이용하실 수 있습니다.'"
                :buttonCount="0"
            />     -->
            <common-modal 
                v-if="isCommonModal"
                :title="'등록된 환자 정보가 없어요.'"
                :message="message"
                :button1Text="'환자 등록하기'"
                :button2Text="'취소'"
                :buttonCount="2"
                @onClose="onCommonModalClose"
                @onClickButton1="onClickButton1"
                @onClickButton2="onClickButton2"
            />            
            <error-modal 
                v-if="error"
                :error="error"
                @onClose="onErrorModalClose"
            />
            <!-- 헤더 -->
            <home-header             
                @logout="logout"
            />
            <notice 
                @open="openOutlinkPopup"
            />
            <div class="line"></div>
            <!-- 공지사항 -->
            <!-- 전극 구매 예상일 -->
            <d-day-list 
                v-if="expireData"
                :profileData="expireData"
                style="margin-top: 16px;"
            />

            <!-- 외부 링크 -->
            <div class="layout">
                <div class="first-guide" @click="openHowToUse">
                    <div>
                        💡
                        <span class="guide-text">솔닥 컨시어지가 처음이세요?</span>
                    </div>

                    <img style="width: 22px;" src="../assets/right_arrow_icn.png" />
                </div>
            </div>
            <!-- <div class="friend-apply-bar">
                <div class="friend-apply" @click="goInvite">
                    <div class="friend-apply-content">
                        <span class="friend-apply-title">🎁 &nbsp;솔닥 컨시어지 초대하기</span>
                        <span class="friend-apply-desc">친구에게 솔닥을 알려주세요</span>
                    </div>
                    <img style="width: 22px;" src="../assets/right_arrow_icn.png" />
                </div>
            </div> -->
            <div class="layout-background">
                <div class="button-area">
                    <span class="button-area-title">서비스 이용</span>
                    <div class="row" style="margin-top: 20px;">
                        <div class="apply-button" @click="showMessenger">
                            <span>진료·구매하기</span>
                            <img class="apply-btn-image" src="../assets/apply_button_img.png" />
                        </div>
                        <div class="col" style="margin-left: 4px;" @click="goRegister">
                            <div class="patient-info-button">
                                <img class="use-btn-image" src="../assets/add_user_icn.png" />
                                <span>환자 등록</span>
                            </div>
                            <div class="patient-info-button" @click="medicalInfo">
                                <img class="use-btn-image" src="../assets/use_button_img.png" />
                                <span>이용내역 보기</span>
                            </div>
                        </div>
                    </div>
                    <div class="card-info-button" style="margin-top: 8px;" @click="goApply">
                        <div style="display: flex;justify-content: flex-start;align-items: center;">
                            <img class="patient-info-image" src="../assets/patient_info_img.png" />
                            <span style="margin-left: 8px;">환자정보 관리</span>
                        </div>
                        <img src="../assets/right_arrow_gray.png" />
                    </div>
                </div>
            </div>
            <!-- 버튼 레이아웃 -->

            <!-- 주변기능 -->
            <div class="layout" style="padding-top: 20px;">
                <span class="button-area-title">당뇨 맞춤 서비스</span>
                <div class="row" style="margin-top: 20px">
                    <div class="button-col" @click="openCalc">
                        <div class="button-back">
                            <img src="../assets/calc2.png" />
                        </div>
                        <span class="button-title">소모품 계산기</span>
                    </div>
                    <div class="button-col" @click="openProduct">
                        <div class="button-back">
                            <img src="../assets/list2.png" />
                        </div>
                        <span class="button-title">구매가능 품목</span>
                    </div>
                    <div class="button-col">
                        <div class="button-back" @click="openSearchPharmacy">
                            <img style="width: 22px;" src="../assets/pharmacy2.png" />
                        </div>
                        <span class="button-title">인슐린 약국</span>
                    </div>
                </div>
            </div> 
            <!-- footer -->
            <div class="help-info">
                <div class="icon-list">
                    <img @click="openLink('https://concierge.soldoc.co.kr/barocarenew')" style="width: 57px;cursor: pointer;" src="../assets/home_page_icn.png" />
                    <img @click="openLink('https://youtu.be/cVzvhdmQe04?si=qvH2tKEeK20NPJG-')" style="width: 57px;cursor: pointer;" src="../assets/youtube_icn.png" />
                    <img @click="openLink('https://blog.naver.com/PostList.naver?blogId=soldoc_concierge&from=postList&categoryNo=1')" style="width: 57px;cursor: pointer;" src="../assets/blog_icn.png" />
                </div>
                <span class="text9">고객센터</span>
                <div class="row2" style="margin-top: 16px;">
                    <span class="text10">전화번호: 02-6954-7682</span>
                </div>
                <div class="row2" style="margin-top: 4px;"> 
                    <span class="text10">운영시간: 평일 09시 ~ 18시</span>
                </div>
            </div>
            <div class="footer-box">
                <page-footer />
            </div>
        </div>
    </div>
</template>

<script>
import cookies from '@/utilities/cookie.js';
import Constant from '@/constant';
import {mapState} from 'vuex';

import HomeHeader from '@/components/molecules/home/HomeHeader';
import PageFooter from '@/components/molecules/PageFooter';
import Loading from '@/components/molecules/Loading';
import CommonModal from '@/components/modals/CommonModal';
import ErrorModal from '@/components/modals/ErrorModal';
import Notice from '@/components/molecules/Notice';
import DDayList from '@/components/molecules/DDayList';
import OutlinkPopup from '@/components/modals/OutLinkPopup';
import NotificationModal from '@/components/modals/NotificationModal';

export default {
    name: 'home',
    components: {HomeHeader, PageFooter, Loading, CommonModal, ErrorModal, Notice, DDayList, OutlinkPopup, NotificationModal},
    computed: mapState(['diabetes_profiles']),
    data: function()
    {
        return {
            access_token: null,
            isLoading: false,
            message: "환자 정보를 먼저 등록해 주세요.<br>‘환자 등록하기' 버튼을 클릭하여 이용해 주세요.",
            isCommonModal: false,
            kakaoId: null,
            phoneNumber: null,
            error: null,
            isOutlinkPopup: false,
            outLink: null,
            isProfileLoading: false,
            profileData: null,
            expireData: null,
            isNotification: true,
            multipleProfiles: false,
            name: '',
            birth: '',
            mobileNumber: "",
            delegate: "",
            delegateStartDate: '',
            diabetesType: '',
            address: '',
            card: '',
            lastCheckoutCompletedAt: '',
            purchasedCount: 0,
            mkt: false
        }
    },
    mounted: async function()
    {
        //

        this.topFunction();
        // token
        // if not verified login page로 이동
        // else 
        this.access_token = cookies.getLocalStorage("access_token");
        

        if(this.access_token === null || this.access_token === undefined || this.access_token === '')
        {
            this.access_token = cookies.deleteLocalStorage("access_token");
            this.$router.push({path: '/', query: {returnUrl: 'home'}})
        }
        else
        {

            if(this.diabetes_profiles.length === 0)
            {
                
                this.isLoading = true;
                
            }
            else 
            {
                this.profileData = this.diabetes_profiles;
            }

            this.$store.dispatch(Constant.FETCH_EXPECTED_DATE, {token: this.access_token})
                .then((res) => {                    
                    this.expireData = res;   
                }) 
                .catch(() => {

                    this.access_token = cookies.deleteLocalStorage("access_token");
                    this.$router.push({path: '/', query: {returnUrl: 'home'}})
                })



            // 유효성 체크    
            this.$store.dispatch(Constant.FETCH_PROFILES, {token: this.access_token})
                .then((res) => {
                   
             
                        this.profileData = res;
                        this.channelTalkProfileDataSplit(this.profileData);
                         ChannelIO('boot', {
                            "pluginKey": "90e69520-1088-43c6-a1cc-3019437a9be8",
                            profile: {
                                multipleProfiles: this.multipleProfiles,
                                name: this.name,
                                birth: this.birth,
                                mobileNumber: this.mobileNumber,
                                delegate: this.delegate,
                                delegateStartDate: this.delegateStartDate,
                                diabetesType: this.diabetesType,
                                address: this.address,
                                card: this.card,
                                lastCheckoutCompletedAt: this.lastCheckoutCompletedAt,
                                purchasedCount: this.purchasedCount,
                                mkt: this.mkt
                            },
                            language: 'ko'
                        });

                        this.isLoading = false;
                           
                }) 
                .catch(() => {
                    this.access_token = cookies.deleteLocalStorage("access_token");
                    this.$router.push({path: '/', query: {returnUrl: 'home'}})
                    this.isLoading = false;
                })
        }
    },
    methods: {
        channelTalkProfileDataSplit: function(profile)
        {
            if(profile === null || profile.length === 0)
            {
                return;
            }

            const first = profile[0];
            this.multipleProfiles = profile.length > 1;

            if(this.multipleProfiles)
            {
                // 복수 프로필: 이름만 모두 표시, 나머지 빈값
                this.name = profile.map(p => p.profile.name).join(', ');
                return;
            }

            // 단일 프로필
            this.name = first.profile.name;

            // birth (registration_number에서 파싱)
            if(first.profile.registration_number)
            {
                const regNum = first.profile.registration_number;
                const yy = regNum.substring(0, 2);
                const mm = regNum.substring(2, 4);
                const dd = regNum.substring(4, 6);
                const genderDigit = regNum.substring(6, 7);
                const century = (genderDigit === '1' || genderDigit === '2') ? '19' : '20';
                this.birth = `${century}${yy}-${mm}-${dd}`;
            }

            // mobileNumber
            this.mobileNumber = `+82${first.profile.phone_number}`;

            // delegate
            if(first.delegation_info.is_delegated)
            {
                this.delegate = '위임함';
                this.delegateStartDate = first.delegation_info.started_at.substring(0, 10);
            }
            else
            {
                this.delegate = '위임안함';
            }

            // diabetesType
            const typeMap = {
                'TYPE1': '1형당뇨',
                'TYPE2': '2형당뇨',
                'GESTATIONAL': '임신성당뇨(투여)',
                'GESTATIONAL_WITHOUT_INSULIN': '임신성당뇨(미투여)'
            };
            this.diabetesType = typeMap[first.profile.diabetes_type] || '';

            // address
            this.address = `${first.profile.address === null ? '입력안함' : first.profile.address} ${first.profile.address_description === null ? '' : first.profile.address_description}`;

            // card
            if(first.card_info !== null)
            {
                this.card = first.card_info.card_name + ' ' + first.card_info.card_number;
            }
            else
            {
                this.card = '카드미등록';
            }


        },  
        notificationModalClose: function()
        {
            this.isNotification = false;
        },
        notificationCloseNeverAgain: function()
        {
            this.isNotification = false;
            cookies.setLocalStorage("neveragain02", true);
        },
        topFunction: function() {
            document.body.scrollTop = 0; // For Safari
            document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
        }, 
        onErrorModalClose: function()
        {
            this.error = null;
        },
        onCommonModalClose: function()
        {
            this.isCommonModal = false;
        },
        onClickButton1: function()
        {
            this.isCommonModal = false;
            this.$router.push({path: '/register'})            
        },
        onClickButton2: function()
        {
            this.isCommonModal = false;
        },
        openOutlinkPopup: function(link)
        {
            window.open(link, "_blank")
        },
        closeOutlinkPopup: function()
        {
            this.isOutlinkPopup = false;
            this.outLink = null
        },
        openHowToUse: function()
        {
            window.open("https://docs.channel.io/solcon/ko/articles/%EC%84%9C%EB%B9%84%EC%8A%A4-%EC%9D%B4%EC%9A%A9%EB%B0%A9%EB%B2%95-1bfb7f0c", "_blank")
        },
        logout: function()
        {
            this.access_token = cookies.deleteLocalStorage("access_token");
            this.$router.push({path: '/', query: {returnUrl: 'home'}})
        },
        cardUpdate: function()
        {
            if(this.diabetes_profiles.length > 0)
            {
                this.$router.push({path: '/cardupdate'})
            }
            else
            {
                // 등록된 환자 정보가 없어요 모달 
                this.isCommonModal = true;                
            }
        },
        addressManagement: function()
        {
             if(this.diabetes_profiles.length > 0)
            {
                this.$router.push({path: '/address'})
            }
            else
            {
                // 등록된 환자 정보가 없어요 모달 
                this.isCommonModal = true;                
            }
        },
        goRegister: function()
        {
            this.$router.push({path: '/register'})
        },
        goApply: function()
        {
            if(this.diabetes_profiles.length > 0)
            {
                this.$router.push({path: '/apply'})
            }
            else
            {
                // 등록된 환자 정보가 없어요 모달 
                this.isCommonModal = true;
                
            }
            
        },
        medicalInfo: function()
        {

            if(this.diabetes_profiles.length > 0)
            {
                this.$router.push({path: '/info'})
            }
            else
            {
                // 등록된 환자 정보가 없어요 모달 
                this.isCommonModal = true;                
            }
        },
        showMessenger: function()
        {
            ChannelIO('showMessenger');
        },
        openCalc: function()
        {
            this.$router.push({path: '/calc', query: {isback: 'true'}})
        },
        openProduct: function(){
            window.open("https://concierge.soldoc.co.kr/barocarenew/sub1", "_blank")
        },
        openSearchPharmacy: function()
        {
            this.$router.push({path: '/pharmacy-map', query: {isback: 'true'}})
            // window.open("https://concierge.soldoc.co.kr/barocarenew/sub5", "_blank")
        },
        openLink(link) {
            window.open(link, "_blank")
        },
        goInvite() {
            this.$router.push({path: '/invite'})
        }
    }, // method

}
</script>

<style scoped>
    .wrapper {
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .page {
        width: 100%;
        background: var(--Gray-20, #FFF);
    }
    /* layout */
    @media (min-width: 600px) {
        .page {
            width: 600px;
        }
    }
    .layout {
        width: 100%;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;
        box-sizing: border-box;
        padding: 20px 16px 4px 16px;
    }
    .layout-background {
        width: 100%;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;
        box-sizing: border-box;
        padding: 20px 16px;
        background: var(--Gray-20, #F3F5F8);
    }
    .friend-apply-bar {
        width: 100%;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;
        box-sizing: border-box;
        padding: 4px 16px 20px 16px;
    }
    .friend-apply {
        border-radius: 6px;
        background: linear-gradient(135deg, #184FA1 0%, #2B6CD4 100%);
        width: 100%;
        display: flex;
        box-sizing: border-box;
        padding: 16px 20px;
        justify-content: space-between;
        align-items: center;
        cursor: pointer;
    }
    .friend-apply-content {
        display: flex;
        flex-direction: column;
    }
    .friend-apply-title {
        color: #FFF;
        font-family: Pretendard;
        font-size: 18px;
        font-weight: 600;
        line-height: 22px;
        letter-spacing: -0.36px;
    }
    .friend-apply-desc {
        color: rgba(255, 255, 255, 0.7);
        font-family: Pretendard;
        font-size: 14px;
        font-weight: 400;
        line-height: 20px;
        margin-top: 4px;
    }


    .first-guide {
        border-radius: 6px;
        background: #6B7684;
        width: 100%;
        display: flex;
        box-sizing: border-box;
        padding: 0 20px;
        height: 40px;
        justify-content: space-between;
        align-items: center;
        cursor: pointer;
    }
    .guide-text {
        color: var(--Gray-00, #FFF);
        font-family: Pretendard;
        font-size: 18px;
        font-style: normal;
        font-weight: 600;
        line-height: 22px; /* 122.222% */
        letter-spacing: -0.36px;
        margin-left: 8px;
    }
    .button-area {
        display: flex;
        width: 100%;
        justify-content: flex-start;
        align-items: flex-start;
        flex-direction: column;
    }
    .button-area-title {
        color: var(--Gray-100, #1E1E1E);
        font-family: Pretendard;
        font-size: 20px;
        font-style: normal;
        font-weight: 600;
        line-height: 28px; /* 140% */
    }
    .row {
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;
    }
    .apply-button {
        border-radius: 6px;
        background: #184FA1;
        width: calc(48% - 4px);   
        height: 128px;
        box-sizing: border-box;
        padding: 16px;
        position: relative;
        color: var(--Gray-00, #FFF);
        font-family: Pretendard;
        font-size: 20px;
        font-style: normal;
        font-weight: 500;
        line-height: 24px; /* 120% */
        cursor: pointer;
    }
    .apply-btn-image {
        position: absolute;
        right: 16px;
        bottom: 16px;
        width: 48px;
    }
    .col {
        display: flex;
        flex-direction: column;
        width: calc(52% - 4px);  
        height: 128px;
        justify-content: space-between;
        align-items: flex-start;
    }
    .patient-info-button {
        width: 100%;
        height: 60px;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        box-sizing: border-box;
        padding: 0 12px 0 8px;
        color: var(--Gray-100, #1E1E1E);
        font-family: Pretendard;
        font-size: 18px;
        font-style: normal;
        font-weight: 500;
        line-height: 24px; /* 133.333% */
        border-radius: 6px;
        background: var(--Gray-00, #FFF);
        cursor: pointer;
    }
    .patient-info-image {
        width: 26px;
        margin-right: 10px;
    }
    .use-btn-image {
        width: 22px;
        margin-right: 10px;
    }
    .card-info-button {
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        border-radius: 6px;
        background: var(--Gray-00, #FFF);
        height: 56px;
        box-sizing: border-box;
        padding: 0 20px;
        color: var(--Gray-100, #1E1E1E);
        font-family: Pretendard;
        font-size: 18px;
        font-style: normal;
        font-weight: 500;
        line-height: 24px; /* 133.333% */
        cursor: pointer;

    }
    .button-col {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        cursor: pointer;
    }
    .button-back {
        display: flex;
        width: 49px;
        height: 49px;
        border-radius: 50%;
        background: #F3F5F8;
        justify-content: center;
        align-items: center;
    }
    .button-title {
        color: var(--Gray-100, #1E1E1E);
        text-align: center;
        font-family: Pretendard;
        font-size: 18px;
        font-style: normal;
        font-weight: 500;
        line-height: 22px; /* 122.222% */
        margin-top: 8px;
    }
    .footer-box {
        width: 100%;
        border-top: 1px solid #E8EAEE;
        box-sizing: border-box;
        padding-left: 16px;
        background: var(--Gray-sub-color1, #F3F5F8);
    }
    .help-info {
        width: 100%;
        box-sizing: border-box;
        padding: 32px 16px;
        background: var(--Gray-sub-color1, #F3F5F8);
    }
    .text9 {
        color: var(--Gray-60, #6B7684);
        font-family: Pretendard;
        font-size: 20px;
        font-style: normal;
        font-weight: 600;
        line-height: 28px; /* 140% */
    }
    .text10 {
        color: var(--Gray-60, #6B7684);
        font-family: Pretendard;
        font-size: 18px;
        font-style: normal;
        font-weight: 500;
        line-height: 22px; /* 122.222% */
    }
    .row2 {
        display: flex;
        justify-content: flex-start;
        align-items: center;
    }
    .icn6 {
        width: 22px;
    }
    .line {
        margin-top: 10px;
        width: 100%;
        height: 8px;
        background: var(--Gray-sub-color1, #F3F5F8);
    }
    .icon-list {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        gap: 16px;
        margin-bottom: 10px;
    }
</style>


// WEBPACK FOOTER //
// src/page/Home.vue